import React from 'react'
import ZaloPay from '../../../../assets/TikTok/zalopaylogo.png'
import * as style from './ContentCenter.module.css'

export const BlockImg = ({ srcImg, altImg }) => (
    <span className={`${style.borderImg} ${style.tiktokImg}`}> 
        <img width="36px" height="36px" src={srcImg} alt={altImg} />
    </span>

)

export const ContentCenter = ({ bindingInfo }) => {
    const { app_icon_url, merchant_name } = bindingInfo || ''

    return (
        <section id="contentCenter" style={{marginTop: '75px'}}>
            <div className={style.layoutImgBlock}>
                <BlockImg srcImg={app_icon_url} altImg="logo merchant"/>
                <BlockImg srcImg={ZaloPay} altImg="logo zalopay"/>
            </div>

            <p className={style.textBottomImg}>Liên kết với Zalopay để sử dụng các dịch vụ của {merchant_name}</p>
        </section>
    )
}
